import React from 'react';

import ReactGA from "react-ga4";

//import axios from "axios";
//import ReactPlayer from 'react-player'

import 'video-react/dist/video-react.css'; // import css

import { Player } from 'video-react';

import 'react-slideshow-image/dist/styles.css'
import { Slide } from 'react-slideshow-image';

const Home = (props) => {
	
    ReactGA.initialize("G-27TG8SK2YR");
    // Send pageview with a custom path
    //ReactGA.send({ hitType: "pageview", page: "/", title: "Home" });

    // Send a custom event   
    ReactGA.event({
  	category: "Category_HomeVisit",
  	action: "Home page visited",
  	label: "Home page label", // optional
  	value: 100, // optional, must be a number
  	nonInteraction: true, // optional, true/false
  	transport: "xhr", // optional, beacon/xhr/image
    });	

    const slideImages = [
        {
            id: "product-digital-data",
            contentOnRight: true,
            icon: "bi bi-card-checklist",
            heading: "Convert pdf document to excel using AI",
            content: "Convert PDF document or images to excel using AI based data extraction. But that is not all, you can convert picture to words or excel. Save time, effort and money of reading and typing data into spreadsheets.",
            url: 'https://aimindpro.s3.ap-south-1.amazonaws.com/DigitalDataExtraction.mp4',
            width: '50%'
        },
	    {
            id: "product-expert-ai-assistant",
            contentOnRight: false,
            icon: "bi bi-award-fill",
            heading: "Your own expert system built using Generative AI",
            content: "Power your business with the full potential of Gen AI and creative thinking. Create a completely AI driven interactive customer experience that also gathers data simultaneously! Use the data for any further use, such as, prepare a report or a customer summary. Do all of this without any human intervention. Here is a use case of an AI assistant to a doctor who can interview a patient, scan through patient’s current medical symptoms, history, and use of medicines. Thereafter, the assistant prepares a summary, confirms with the patient, and prepares the doctor for an actual visit. It can work with any number of patients simultaneously. It saves an enormous amount of time and money!",
            url: 'https://aimindpro.s3.ap-south-1.amazonaws.com/Medical-PreInterview.mp4',
            width: '50%'
        },
        {          
            id: "product-video-avatar",
            contentOnRight: true,
            icon: "bi bi-soundwave",
            heading: "AI video generator with Avatar",
            content: "Let an AI generated avatar present your content in a seamless manner. Smart AI avatars will work faster without any maintenance hassles. The avatar will narrate the content with seamless human like gestures. You can choose the model, their appearance, or the vocal tone as you wish. There is no need of creating video or shooting with models.",
            url: 'https://aimindpro.s3.ap-south-1.amazonaws.com/Avatar.mp4',
            width: '50%'
        },
        {
            id: "product-audio-content",
            contentOnRight: false,
            icon: "bi bi-microsoft",
            heading: "AI voice generator",
            content: "Turn your text into an exciting audio using AI. Choose the right voice or a combination of voices. Attract the customer with the right voice and an awesome pre-sales experience. This automated voice will create a great product expectation and will improve brand value. Again, no hassle of voice recording and no recurring maintenance!",            
            url: 'https://aimindpro.s3.ap-south-1.amazonaws.com/AudioContentGeneration.mp4',
            width: '50%'
        }    
      ];

    /*  
    const msg = {name:'', email: '', subject:null, message: ''};
    const [mail, setMail] = React.useState(msg);
    const [message, setMessage] = React.useState("");
    const sucessMessage = "Your message is sent successfully. We would get back to you within three business days." ;
    const errorMessage = "Your message is sent successfully. We would get back to you within three business days" ;

    function handleSubmit(e){
        e.preventDefault();
        const url = '/notification';
        const header = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          };
        axios.post( url, mail , {
            headers: header
          }).then(function (response) {
            //sconsole.log(response);
            if(response.status == 200 && response.statusText == "OK"){
                setMessage(sucessMessage);
                console.log(sucessMessage);        
            }else{
            setMessage(errorMessage+response.statusText); 
            }    
        })
        .catch(function (error) {
            setMessage(errorMessage+error.message); 
        });
    }
    function handleChange (e){
        mail[e.target.name] = e.target.value;
        setMail({ ...mail });
        //console.log(mail);
      };
    */

    return ( 
    <>

    <section id="home" class="d-flex flex-column justify-content-center align-items-center">
        <div class="container text-center text-md-left" data-aos="fade-up">
        <h1>{props.name}, the AI for business</h1>
        <h2>Go faster and grow faster with Generative AI based solutions for your business.</h2>            
        
        <Slide>
            {slideImages.map((slideImage, index)=> (
            <div key={index}>
        
            <div class="row">
                <div class="col-md-12">
                    <div class="center">
                        <br/><br/>
                        <h2>{slideImage.heading}</h2>
                    </div>
                </div>                  
            </div>
        
            </div>
            ))} 
        </Slide>
        <br/>
        <a href="#products" class="btn-get-started scrollto">Get Started</a>
        </div>
    </section>

    <main>

    {/* <!-- ======= Products Section ======= -->*/}
    <section id="products" class="services section-bg">
    <div class="container">

        <div class="section-title">
            <h2>Products</h2>
            <p>We offer following products</p>
        </div>

        <div class="row">

            {slideImages.map((slideImage, index)=> (            

                  slideImage.contentOnRight?
                    <>
                        <div class="col-md-6 mt-6 mt-lg-0">
                            <Player>
                                <source src={slideImage.url} />
                            </Player>
                        </div>
                        <div class="col-md-6 mt-6 mt-lg-0">
                            <div class="icon-box">
                            <i class={slideImage.icon}></i>
                            <h2><a href="#"> {slideImage.heading} </a></h2>
                            <p>{slideImage.content}</p>
                            </div>
                        </div> 
                        <div class="col-md-12 mt-6 mt-lg-0">
                            <p><br/><br/><br/></p>
                        </div> 
                    </>
                    :
                    <>
                        <div class="col-md-6 mt-6 mt-lg-0">
                            <div class="icon-box">
                            <i class={slideImage.icon}></i>
                            <h2><a href="#"> {slideImage.heading} </a></h2>
                            <p>{slideImage.content}</p>
                            </div>
                        </div> 
                        <div class="col-md-6 mt-6 mt-lg-0">
                            <Player>
                                <source src={slideImage.url} />
                            </Player>
                        </div>
                        <div class="col-md-12 mt-6 mt-lg-0">
                            <p><br/><br/><br/></p>
                        </div>
                    </>
            ))}

        </div>
    </div>
    </section>
    {/*<!-- End Products Section -->*/}


    {/*-- ======= Services Section ======= --*/}
    <section id="services" class="services section-bg">
    <div class="container">

        <div class="section-title">
        <h2>Services</h2>
        <p>Our experience for most optimal cost-effective solution to your business problem</p>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="icon-box">
                <i class="bi bi-briefcase"></i>
                <h4><a href="#">Consulting</a></h4>
                <p>Digital transformation journey</p>
                <p>Cloud-native solution for specific business domain</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="icon-box">
                <i class="bi bi-briefcase"></i>
                <h4><a href="#">Consulting</a></h4>
                <p>Latest of Generative AI to accelerate your business</p>
                <p>Rapidly build and deploy a multi-tenant SaaS application</p>
                </div>
            </div>
        </div>

    </div>
    </section>  
    {/*-- End Services Section --*/}


    <section id="contact" class="services section-bg">
        <div class="container">
            <div class="section-title">
            <h2>Contact Us</h2>
            <p>Want to discuss how to optimize your IT, and make it more business-centric? Please write at <p><b>enterprisecloudarch@gmail.com</b></p></p>
            </div>
        </div>
        </section>  

        {/*-- ======= About Section ======= --
        <section id="about" class="services section-bg">
        <div class="container">

            <div class="section-title">
                <h2>About</h2>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <p>We are a small team of experienced software professionals, with a passion for AI and its application in business.</p>
                    <ul>
                        <li><i class="bi bi-bookmark-check-fill"></i> Digital transformation journey</li>
                        <li><i class="bi bi-bookmark-check"></i> </li>
                        <li><i class="bi bi-bookmark-check-fill"></i> Leverage power latest </li>
                        <li><i class="bi bi-bookmark-check"></i> </li>
                    </ul>
                </div>
            </div>

        </div>
        </section> 
        
        <section id="contact" class="services section-bg">
        <div class="container">

            <div class="section-title">
            <h2>Contact</h2>
            <p>Want to discuss how to optimize your IT, and make it more business-centric? Please write to us.</p>
            </div>

            <div class="col-lg-12">

                <div class="row">

                    <div class="col-lg-6 info mt-6 mt-lg-0">
                        <i class="bi bi-envelope"></i>
                        <h5>Email:</h5>enterprisecloudarch@example.com
                    </div>

                    <div class="col-lg-6 info mt-6 mt-lg-0">
                        <i class="bi bi-phone"></i>
                        <h5>WhatsApp:</h5>+91 79809 42903
                    </div>

                </div>

            </div>

            <div class="col-lg-12">
                
                <form onSubmit={handleSubmit} method="post" role="form" class="php-email-form">
                    <div class="row">

                        <div class="section-title">
                        {
                            message != ''?
                                <h5 className="blink">{message}</h5>
                            :
                            <> </>
                        }
                        </div>

                        <div class="col-md-12 form-group">
                        
                        </div>
                        <div class="col-md-6 form-group">
                            <input type="text" name="name" id="name" onChange={handleChange} class="form-control" id="name" placeholder="Your Name" required/>
                        </div>
                        <div class="col-md-6 form-group mt-3 mt-md-0">
                            <input type="email" class="form-control" name="email" id="email" onChange={handleChange} placeholder="Your Email" required/>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <input type="text" class="form-control" name="subject" id="subject" onChange={handleChange} placeholder="Subject" required/>
                    </div>
                    <div class="form-group mt-3">
                        <textarea class="form-control" name="message" rows="5" id="message" onChange={handleChange} placeholder="Message" required></textarea>
                    </div>
                    <div class="my-3">
                        <div class="loading">Loading</div>
                        <div class="error-message"></div>
                        <div class="sent-message">Your message has been sent. Thank you!</div>
                    </div>
                    <div class="text-center"><button type="submit">Send Message</button></div>
                </form>
            </div>
            
        </div>
        </section>
        -- End Contact Section --*/}

    </main>

    </>
    );
}
export default Home;